import { render, staticRenderFns } from "./msg5.vue?vue&type=template&id=3042cba2&"
import script from "./msg5.vue?vue&type=script&lang=js&"
export * from "./msg5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports